"use strict";

exports.__esModule = true;
exports.LoyaltyClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const LoyaltyClient = {
  /**
   *
   * @returns {Promise}
   *
   * @description check loyalty balance
   */
  checkBalance(id = '') {
    const requestId = `LOYALTY_CHECK_BALANCE${id}`;
    const endPoint = _constants.ENDPOINTS.LOYALTY_CHECK_BALANCE;
    return _http.$http.post(requestId, endPoint, {
      data: {}
    }).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description check history loyalty
   */
  checkHistory() {
    const requestId = 'LOYALTY_CHECK_HISTORY';
    const endPoint = _constants.ENDPOINTS.LOYALTY_CHECK_HISTORY;
    return _http.$http.post(requestId, endPoint, {
      data: {}
    }).then(({
      data
    }) => data);
  },
  getLoyalties(provider) {
    const requestId = 'LOYALTY_LIST';
    const endPoint = _constants.ENDPOINTS.LOYALTIES_API;
    return _http.$http.get(requestId, endPoint, {
      params: {
        provider
      }
    }).then(({
      data
    }) => data);
  },
  saveLoyalty(data) {
    const requestId = 'LOYALTY_SAVE';
    const endPoint = _constants.ENDPOINTS.LOYALTIES_API;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  updateLoyalty(data, referenceId) {
    const requestId = 'LOYALTY_UPDATE';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.LOYALTIES_API_UPDATE_DELETE, {
      referenceId
    });
    return _http.$http.put(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  deleteLoyalty(referenceId) {
    const requestId = 'LOYALTY_DELETE';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.LOYALTIES_API_UPDATE_DELETE, {
      referenceId
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  },
  preferredLoyalty(data) {
    const requestId = 'LOYALTY_DELETE';
    const endPoint = _constants.ENDPOINTS.PREFERRED_LOYALTY;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  }
};
exports.LoyaltyClient = LoyaltyClient;